module.exports = __webpack_public_path__ + "static/footer-logo-ad4be006fe0d4716eb141817bfc76aeb.png";